import React, { useState } from "react";
import { slugify } from "transliteration";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import styles from "../../styles/Select.module.css";
import { AutocompleteInputCustom } from "./AutocompleteInputCustom";

interface Option {
  label: string;
  key: string;
}

export const OptionsDocType = ({
  onUpdate,
  initialOptions,
  attributesCommon,
  style,
}: {
  onUpdate: (options: Option[], isValid: boolean) => void;
  initialOptions?: Option[];
  attributesCommon: any;
  style?: React.CSSProperties;
}) => {
  const [duplicateIndexes, setDuplicateIndexes] = useState<number[]>([]);
  const [options, setOptions] = useState<Option[]>(
    initialOptions && initialOptions.length > 0
      ? initialOptions
      : [
          { label: "", key: "" },
          { label: "", key: "" },
        ],
  );

  const validateOptions = (currentOptions: Option[]) => {
    const labels = currentOptions.map((opt) => opt.label.trim().toLowerCase());
    const duplicates: number[] = [];

    labels.forEach((label, index) => {
      if (label && labels.indexOf(label) !== index) {
        labels.forEach((l, i) => {
          if (l === label) duplicates.push(i);
        });
      }
    });

    const uniqueDuplicates = Array.from(new Set(duplicates));
    setDuplicateIndexes(uniqueDuplicates);
    onUpdate(currentOptions, uniqueDuplicates.length === 0);
  };

  const handleChange = (index: number, value: string) => {
    const newOptions = [...options];
    newOptions[index].label = value;
    newOptions[index].key = slugify(value, { separator: "_" });

    setOptions(newOptions);
    validateOptions(newOptions);
  };

  const removeOption = (index: number) => {
    const filtered = options.filter((_, i) => i !== index);
    setOptions(filtered);
    validateOptions(filtered);
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "12px",
          ...style,
        }}
      >
        {options.map((opt, index) => {
          const isDuplicate = duplicateIndexes.includes(index);
          return (
            <div key={index} className={styles.rowGroup}>
              <div className={styles.row}>
                <input
                  className={`${styles.select} ${isDuplicate ? styles.errorRow : ""}`}
                  value={opt.label}
                  autoFocus={index === 0}
                  placeholder={`Варіант ${index + 1}`}
                  onChange={(e) => handleChange(index, e.target.value)}
                />
                {options.length > 2 && (
                  <button
                    className={styles.deleteBtn}
                    onClick={() => removeOption(index)}
                  >
                    ×
                  </button>
                )}
              </div>
              {isDuplicate && (
                <span className={styles.errorText}>
                  Такий варіант уже існує
                </span>
              )}
            </div>
          );
        })}
      </div>
      <AutocompleteInputCustom
        multiple={true}
        label={"Додаткові параметри"}
        value={attributesCommon.list[0].title}
        options={attributesCommon.list}
        onChange={(opt) => {
          setAttrType(opt ? [String((opt as any).id)] : []);
        }}
        placeholder="Оберіть або введіть "
      />

      <button
        className={styles.addBtn}
        onClick={() => setOptions([...options, { label: "", key: "" }])}
      >
        <div className={styles.plusIcon}>
          <AddCircleIcon
            sx={{ height: "40px", width: "40px", color: "#E4ECFF" }}
          />
        </div>
        <span>Додати</span>
      </button>
    </div>
  );
};
